webpackJsonp([188029690210722],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo ideation.d255a8df.png";

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/whiteboard.09b1b40e.png";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PaintChips.a48cc0c4.png";

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _whiteboard = __webpack_require__(56);
	
	var _whiteboard2 = _interopRequireDefault(_whiteboard);
	
	var _PaintChips = __webpack_require__(131);
	
	var _PaintChips2 = _interopRequireDefault(_PaintChips);
	
	var _logoIdeation = __webpack_require__(55);
	
	var _logoIdeation2 = _interopRequireDefault(_logoIdeation);
	
	__webpack_require__(10);
	
	__webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'WorkDetail' },
	        _react2.default.createElement(
	            'div',
	            { className: 'twoColLayout' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    ' Paint Chips '
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Paint chips is an app that enables creators, designers, and artists to quickly track and change running lists of color palettes across multiple projects.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Create any number of color palettes, and quickly add and delete new colors to those palettes using an intuitive slider-based UI for arriving at the perfect color.'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    {
	                        className: 'pdfButton',
	                        href: 'https://apps.apple.com/us/app/paint-chips/id1502792725',
	                        rel: 'noopener noreferrer',
	                        target: '_blank'
	                    },
	                    'Download on the iOS App Store'
	                )
	            ),
	            _react2.default.createElement('img', { id: 'appIcon', className: 'threeQuartersImage', src: _PaintChips2.default })
	        ),
	        _react2.default.createElement(
	            'h2',
	            null,
	            ' INSPIRATION '
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'This app came out of the necessity for me to build color palettes combined with the lack of options I was satisfied with to do so.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'My vision was to build a super-simple product that could empower its users to'
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                ' RANDOM STUFF '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Downloads as of July 2021: 2,260'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Released: March 2020'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h2',
	                null,
	                ' TECHNOLOGIES USED '
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'XCode'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'SwiftUI, Swift'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Amazon AWS, Amazon Amplify'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Adobe Illustrator'
	                )
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-paint-chips-js-1b216adb7c0c56d45dbc.js